import api from "../../services/apis/antecipeApi";
import { MomentType, Reason } from "./types";

type Raw = Record<string, unknown>;
const pick = (r: Raw, camel: string, snake: string) => (r[camel] !== undefined ? r[camel] : r[snake]);
const bool = (v: unknown) => v === true || v === 1 || v === "1";

/** Aceita camelCase (contrato do BE-0h) e snake_case (defensivo). */
export const toReason = (r: Raw): Reason => ({
  id: Number(r.id),
  label: String(r.label),
  requiresText: bool(pick(r, "requiresText", "requires_text")),
  isOther: bool(pick(r, "isOther", "is_other")),
});

/** `GET reasons?moment=`: motivos ativos da janela, na ordem do catálogo (o FE embaralha). */
export async function fetchReasons(moment: MomentType): Promise<Reason[]> {
  const response = await api.get("reasons", { params: { moment } });
  const rows = response?.data?.data;
  return Array.isArray(rows) ? (rows as Raw[]).map(toReason) : [];
}
